// 点赞收藏关注接口
import request from '@/utils/request'

// 用户收藏接口
export function submitUserFavorite(data) {
  return request({
    url: '/cultureCantonDemoApi/favoriteLogApi/submitUserFavorite',
    method: 'post',
    data,
  })
}

// 用户取消收藏接口
export function cancelFavorite(data) {
  return request({
    url: '/cultureCantonDemoApi/favoriteLogApi/cancelFavorite',
    method: 'post',
    data,
  })
}

// 用户关注接口
export function submitUserFollow(data) {
  return request({
    url: '/cultureCantonDemoApi/followLogApi/submitUserFollow',
    method: 'post',
    data,
  })
}

// 用户取消关注接口
export function cancelFollow(data) {
  return request({
    url: '/cultureCantonDemoApi/followLogApi/cancelFollow',
    method: 'post',
    data,
  })
}

// 用户点赞接口
export function submitUserPraise(data) {
  return request({
    url: '/cultureCantonDemoApi/praiseLogApi/submitUserPraise',
    method: 'post',
    data,
  })
}

// 用户取消点赞接口
export function cancelPraise(data) {
  return request({
    url: '/cultureCantonDemoApi/praiseLogApi/cancelPraise',
    method: 'post',
    data,
  })
}
